
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 96 96","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"17.25","y":"20.25","width":"61.5","height":"45.5","rx":"5.75","fill":"currentColor","fill-opacity":".07","stroke":"currentColor","stroke-width":"2.5"}}),_c('rect',{attrs:{"x":"25","y":"28","width":"46","height":"30","rx":"3","fill":"currentColor","fill-opacity":".16"}}),_c('path',{attrs:{"d":"M7.25 68.25h81.5v1.5a7 7 0 01-7 7h-67.5a7 7 0 01-7-7v-1.5z","fill":"currentColor","fill-opacity":".07","stroke":"currentColor","stroke-width":"2.5","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M41 72.5h14","stroke":"currentColor","stroke-width":"2.5","stroke-linecap":"round","opacity":".45"}})])
          )
        }
      }
    